// GraphQL returns them camelCased, the REST details endpoint snake_cased.
export function formatExecutionReportExpiration(executionReport = {}) {
  const monthYear =
    executionReport.maturityMonthYear ?? executionReport.maturity_month_year
  const day = executionReport.maturityDay ?? executionReport.maturity_day

  if (!monthYear || !day) return null

  return `${monthYear.slice(0, 4)}-${monthYear.slice(4, 6)}-${day}`
}
